import { BaseService } from "./base.service";
export class UniversityDivisionService extends BaseService {
  constructor() {
    super("university-divisions");
  }
}
